import { Button } from '@/components/ui/button'
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from '@/components/ui/dialog'
import { Spinner } from '@/components/ui/spinner'
import { KBD_SUBMIT_ATTR } from '@/hooks/formKeyboardNav'

type ConfirmDialogProps = {
	open: boolean
	onOpenChange: (open: boolean) => void
	title: React.ReactNode
	description?: React.ReactNode
	confirmLabel?: string
	cancelLabel?: string
	onConfirm?: () => void
	confirmVariant?: 'destructive' | 'default' | 'outline' | 'link' | 'secondary' | 'ghost'
	isLoading?: boolean
}

export function ConfirmDialog({
	open,
	onOpenChange,
	title,
	description,
	confirmLabel = 'Confirm',
	cancelLabel = 'Cancel',
	onConfirm,
	confirmVariant = 'destructive',
	isLoading = false,
}: ConfirmDialogProps) {
	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className='z-[999]'>
				<DialogHeader>
					<DialogTitle>{title}</DialogTitle>
					{description && <DialogDescription>{description}</DialogDescription>}
				</DialogHeader>

				<DialogFooter>
					<Button variant='outline' onClick={() => onOpenChange(false)}>
						{cancelLabel}
					</Button>
					<Button
						variant={confirmVariant}
						disabled={isLoading}
						{...{ [KBD_SUBMIT_ATTR]: '' }}
						onClick={e => {
							e.preventDefault()
							onConfirm?.()
							onOpenChange(false)
						}}>
						{isLoading ? <Spinner className='mr-2' /> : null}
						{confirmLabel}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	)
}
